import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import * as lf from 'localforage';
import { addToStringTag } from '../util/addToStringTag';
/** @internal */
var instance;
/** @internal */
var config = {
    cacheTime: 300000,
    description: '',
    driver: [lf.INDEXEDDB, lf.WEBSQL, lf.LOCALSTORAGE],
    name: 'ngForage',
    size: 4980736,
    storeName: 'ng_forage',
    version: 1
};
/**
 * Global/default configuration
 */
var NgForageConfig = (function () {
    function NgForageConfig() {
    }
    NgForageConfig_1 = NgForageConfig;
    Object.defineProperty(NgForageConfig.prototype, "cacheTime", {
        /**
         * Cache time in milliseconds
         * @default 300000
         */
        get: function () {
            return config.cacheTime;
        },
        set: function (t) {
            config.cacheTime = t;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForageConfig.prototype, "config", {
        /**
         * Get the compiled configuration
         */
        get: function () {
            return {
                cacheTime: this.cacheTime,
                description: this.description,
                driver: this.driver,
                name: this.name,
                size: this.size,
                storeName: this.storeName,
                version: this.version
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForageConfig.prototype, "description", {
        /**
         * A description of the database, essentially for developer usage.
         * @default
         */
        get: function () {
            return config.description;
        },
        set: function (v) {
            config.description = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForageConfig.prototype, "driver", {
        /**
         * The preferred driver(s) to use.
         * @see {@link NgForageConfig#DRIVER_INDEXEDDB}
         * @see {@link NgForageConfig#DRIVER_WEBSQL}
         * @see {@link NgForageConfig#DRIVER_LOCALSTORAGE}
         */
        get: function () {
            if (typeof config.driver === 'string') {
                return config.driver;
            }
            return config.driver.slice();
        },
        set: function (v) {
            config.driver = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForageConfig.prototype, "name", {
        /**
         * The name of the database. May appear during storage limit prompts. Useful to use the name of your app here.
         * In localStorage, this is used as a key prefix for all keys stored in localStorage.
         * @default ngForage
         */
        get: function () {
            return config.name;
        },
        set: function (v) {
            config.name = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForageConfig.prototype, "size", {
        /**
         * The size of the database in bytes. Used only in WebSQL for now.
         * @default 4980736
         */
        get: function () {
            return config.size;
        },
        set: function (v) {
            config.size = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForageConfig.prototype, "storeName", {
        /**
         * The name of the datastore.
         * In IndexedDB this is the dataStore,
         * in WebSQL this is the name of the key/value table in the database.
         * Must be alphanumeric, with underscores.
         * Any non-alphanumeric characters will be converted to underscores.
         * @default ng_forage
         */
        get: function () {
            return config.storeName;
        },
        set: function (v) {
            config.storeName = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForageConfig.prototype, "version", {
        /**
         * The version of your database. May be used for upgrades in the future; currently unused.
         * @default 1.0
         */
        get: function () {
            return config.version;
        },
        set: function (v) {
            config.version = v;
        },
        enumerable: true,
        configurable: true
    });
    NgForageConfig.factory = function () {
        if (!instance) {
            instance = new NgForageConfig_1();
        }
        return instance;
    };
    /**
     * Bulk-set configuration options
     * @param opts The configuration
     */
    NgForageConfig.prototype.configure = function (opts) {
        opts = opts || {};
        if ('driver' in opts && opts.driver.slice) {
            opts.driver = opts.driver.slice();
        }
        Object.assign(config, opts);
        return this;
    };
    /**
     * Define a driver
     *
     * You’ll want to make sure you accept a callback argument and that you pass the same arguments to callbacks as the
     * default drivers do. You’ll also want to resolve or reject promises.
     * Check any of the {@link https://github.com/mozilla/localForage/tree/master/src/drivers default drivers}
     * for an idea of how to implement your own, custom driver.
     * @param spec Driver spec
     */
    NgForageConfig.prototype.defineDriver = function (spec) {
        return lf.defineDriver(spec);
    };
    /** @internal */
    NgForageConfig.prototype.toJSON = function () {
        return this.config;
    };
    /** The IndexedDB driver */
    NgForageConfig.DRIVER_INDEXEDDB = lf.INDEXEDDB;
    /** The localStorage driver */
    NgForageConfig.DRIVER_LOCALSTORAGE = lf.LOCALSTORAGE;
    /** The WebSQL driver */
    NgForageConfig.DRIVER_WEBSQL = lf.WEBSQL;
    /** @internal */
    NgForageConfig.provider = {
        provide: NgForageConfig_1,
        useFactory: NgForageConfig_1.factory
    };
    NgForageConfig = NgForageConfig_1 = tslib_1.__decorate([
        Injectable()
    ], NgForageConfig);
    return NgForageConfig;
    var NgForageConfig_1;
}());
export { NgForageConfig };
Object.freeze(NgForageConfig.provider);
addToStringTag(NgForageConfig, 'NgForageConfig');



//////////////////
// WEBPACK FOOTER
// ./src/NgForage/config/NgForageConfig.service.ts
// module id = 5
// module chunks = 0 1